<template>
    <div>
        <popup :title="title" v-if="openPopup" @close="hidePopup()" @on-cancel-click="hidePopup()" @on-save-click="onSaveClick"
               :displayPopup="openPopup" :showAddNewBtn="false" class="box-popup-sso">
            <b-container style="width:auto; text-align: left;">
                <b-row>
                    <b-col>
                        <div style="padding: 7px; padding-top: 15px; padding-bottom: 0px; text-align: left;">
                            <span style="color: yellow; font-weight: bold;">
                                Single Sign-On Enable/Disable
                            </span>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div style="padding: 7px; padding-top: 0px; padding-bottom: 0px; text-align: left;">
                            <span style="color: white;">Select a Facility</span>
                            <multiselect v-model="selectedFacility"
                                         placeholder="Select Facility" label="Value" track-by="Key"
                                         :options="FacilityList" :taggable="true" :allow-empty="false">

                            </multiselect>

                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div style="padding: 7px; padding-top: 0px; padding-bottom: 0px; text-align: left;">
                            <span style="color: white;">Select a user</span>
                            <multiselect v-model="selectedUser"
                                         placeholder="Select User" label="UserName" track-by="UserID"
                                         :options="UsersList" :taggable="true" :allow-empty="false">

                            </multiselect>

                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div style="padding: 7px; padding-top: 0px; padding-bottom: 0px; text-align: left;">
                            <span style="color: white;">Enter username</span>
                            <b-form-input v-model="NewUsername" placeholder="New Username" style="width: 325px;"></b-form-input>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div style="padding: 7px; padding-top: 0px; padding-bottom: 0px; text-align: left;">
                            <b-form-checkbox style="color: white;" v-model="SSOEnabled" name="check-button" switch>
                                SSO Enabled
                            </b-form-checkbox>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div style="padding: 7px; padding-top: 0px; padding-bottom: 0px; text-align: left;" v-if="USERNAMEEXISTFLAG">
                            <span style="color: orangered;">Username is already in use!</span>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div style="padding: 7px; padding-top: 0px; padding-bottom: 0px; text-align: left;" v-if="USERNOTSELECTED">
                            <span style="color: orangered;">Please select a user!</span>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div style="padding: 7px; padding-top: 0px; padding-bottom: 0px; text-align: left;" v-if="USERNAMEISEMPTY">
                            <span style="color: orangered;">Username field is empty!</span>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </popup>
    </div>
</template>

<script>
    import axios from "axios";
    import { required } from "vee-validate/dist/rules";
    import { extend } from "vee-validate";

    extend("required", {
        ...required,
        message: "This field is required"
    });

    export default {
        name: "sso-popup",
        props: {
        },
        data: function () {
            return {
                openPopup: false,
                UserID: 0,
                title: 'Single Sign-On ',
                textboxNotes: '',
                labelPrimaryDisplayText: '',
                labelSecondaryDisplayText: '',
                UsersList: [],
                FacilityList: [],
                selectedUser: new Object(),
                NewUsername: '',
                selectedFacility: new Object(),
                SSOEnabled: false,
                USERNAMEEXISTFLAG: false,
                USERNOTSELECTED: false,
                USERNAMEISEMPTY: false,
            };
        },
        mounted: function () {
            //mounted is an event in the lifecyle of a vue component
            // console.log('patientId in mounted: ' + this.patientId);
        },
        computed: {

        },
        watch: {
            //'selectedUser': function (newVal, oldVal) {
            //    if (newVal != oldVal) {
            //        let vm = this;
            //        vm.SSOEnabled = vm.selectedUser.SSO_ENABLED;
            //        vm.email = vm.selectedUser.UserName;
            //        //this.$emit("resetValidation");

            //    }
            //},
            'selectedFacility': function (newVal, oldVal) {
                if (newVal != oldVal) {
                    let vm = this;
                    vm.GetUserList();

                    //this.$emit("resetValidation");

                }
            }
        },
        methods: {
            showPopup(UserID, title, primaryText, secondaryText) {
                var vm = this;
                vm.title = 'SSO Popup';
                vm.UserID = UserID;
                vm.openPopup = true;
                vm.labelPrimaryDisplayText = primaryText;
                vm.labelSecondaryDisplayText = secondaryText;
                vm.textboxNotes = '';
                vm.GetSSOFacilities();
                vm.selectedFacility = '';
                vm.selectedUser = '';
                vm.NewUsername = '';
                vm.USERNAMEEXISTFLAG = false;
                vm.USERNOTSELECTED = false;
                vm.USERNAMEISEMPTY = false;
                vm.SSOEnabled = false;
            },
            hidePopup() {
                this.openPopup = false;
            },

            async onSaveClick() {
                var vm = this;
                vm.USERNOTSELECTED = false;
                vm.USERNAMEISEMPTY = false;
                //console.log();
                //vm.selectedUser is an entire object you need to select a property of the object
                if (vm.selectedUser != '' && vm.NewUsername != '') {
                    let response = await axios
                        .post("../../Common/Services/EmarClientOperations.svc/SaveSSOUser",
                            {
                                selectedUser: JSON.stringify(vm.selectedUser),
                                NewUsername: vm.NewUsername,
                                SSOFlag: vm.SSOEnabled,
                            }
                        );

                    let userExistsFlag = JSON.parse(response.data.d);
                    vm.USERNAMEEXISTFLAG = userExistsFlag;
                    if (vm.USERNAMEEXISTFLAG == false)
                        vm.hidePopup();
                }
                else {
                    if(vm.selectedUser == '')
                    vm.USERNOTSELECTED = true;
                    if (vm.NewUsername == '')
                        vm.USERNAMEISEMPTY = true;
                }
                
                //this.$emit("OnDeleteClick");
                
            },
            async GetUserList() {

                var vm = this;

                let response = await axios

                    .post("../../../Common/Services/EmarClientOperations.svc/GetAllUsers",
                        {
                            FacID: vm.selectedFacility.Key,
                        });
                    vm.UsersList = [];
                    vm.UsersList = JSON.parse(response.data.d);

            },

            async GetSSOFacilities() {

                var vm = this;

                let response = await axios.post("../../../Common/Services/EmarClientOperations.svc/GetAllSSOFacilities");

                    
                vm.FacilityList = [];
                vm.FacilityList = JSON.parse(response.data.d);

            },
        }
    }
</script>

<style scoped>
    .box-popup-sso {
        width: 460px !important;
        height: 370px !important;
    }

    ::v-deep .multiselect__input {
        border: none !important;
        transition: none !important
    }

    ::v-deep .multiselect__tags {
        width: 100% !important
    }



    ::v-deep .modal-title {
        font-size: 1.25rem;
    }



    ::v-deep *,
    ::after,
    ::before {
        box-sizing: border-box;
    }
</style>